import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'lib-contact-widget-add',
	imports: [
		SharedModule
	],
  templateUrl: './contact-widget-add.component.html',
  styleUrl: './contact-widget-add.component.scss'
})
export class ContactWidgetAddComponent {}
